export const DeviceType = {
  mobile: "Mobile",
  tablet: "Tablet",
  pc: "PC",
};

export const REQUEST_STATUS = {
  success: "success",
  error: "error",
};
